import { render, staticRenderFns } from "./BoardViewBasic.vue?vue&type=template&id=6de56c32"
import script from "./BoardViewBasic.vue?vue&type=script&lang=js"
export * from "./BoardViewBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports